import { useEffect, useState } from "react";
import SvDashboardFilters from "../filters/svdashbordfilters";
import WeekTable from "../tables/weektable";
import dayjs from "dayjs";
import api from "../api/api";
import CircularProgress from "@mui/material/CircularProgress";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Sidenav from "../Sidenav/Sidenav";
import SideNavLayout from "../Sidenav/SideNavLayout";
import Footer from "../auth/Footer";
import useStore from "../Zustand/useStore";

const SuperVisorView = () => {
  const getWeekRange = (date) => {
    const startOfWeek = date.startOf("isoWeek"); // Start of the week (Monday)
    const endOfWeek = date.endOf("isoWeek"); // End of the week (Sunday)
    return {
      startDate: startOfWeek,
      endDate: endOfWeek,
    };
  };

 
  const [isModal, setIsModal] = useState(false);
  const [filterby, setFilterBy] = useState("No Grouping");
const [currentfilter,setCurrentFilter]=useState('All')
const [counts,setCounts]=useState({
  All:0,
  Pending:0,
})
const { selectedWeek, setSelectedWeek } = useStore();
  const [tableLoading, setTableLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [backupdata,setBackpData]=useState([])
  const navigate=useNavigate()
  const [selectedDateRange, setSelectedDateRange] = useState({
    startDate: dayjs().startOf('isoWeek').toDate(),
    endDate: dayjs().endOf('isoWeek').toDate(),
    key: "selection",
  });
  // const [currentDate, setCurrentDate] = useState(getWeekRange(dayjs()));

 const updateWeek = (direction) => {
    const newDate = direction === "prev" 
      ? selectedWeek.startDate.subtract(1, "week") 
      : selectedWeek.startDate.add(1, "week");
      const newWeek = getWeekRange(newDate);
      // setCurrentDate(newWeek);
      // Persist the selected week in Zustand
     setSelectedWeek(newWeek.startDate, newWeek.endDate);

  };

  const user = useSelector((state) => state.user.userDetails);
  // console.log('User',user?.user_roles.role)
  const fetchtable = async () => {
    try {
      setTableLoading(true);
      const response = await api.get("/v1/timesheets", {
        params: {
          start_date: selectedWeek.startDate.format("YYYY-MM-DD"),
          end_date: selectedWeek.endDate.format("YYYY-MM-DD"),
         ...(user?.user_roles?.role === 'Project Manager' && user?.user_info?.company_id && {
         company_id: user.user_info.company_id
  }),
          // start_date: dayjs(selectedDateRange.startDate).format("YYYY-MM-DD"),
          // end_date: dayjs(selectedDateRange.endDate).format("YYYY-MM-DD"),
         ...(user && !['Admin', 'Project Manager'].includes(user?.user_roles?.role) && { supervisor_id: user.phone })
        }
      }
      );
      console.log(response.status,'status')
      if (response.status == 200) {
        const filteredData = response?.data?.map(supervisor => ({
          ...supervisor,
          records: currentfilter === 'Pending'
              ? supervisor.records.filter(record => record.overall_status === "PENDING")
              : supervisor.records // Keep all records if filter is not 'Pending'
      }));
  
      setTableData(filteredData || []);
      setBackpData(filteredData||[])
        // Extract all records from supervisors
        const allRecords = response?.data?.flatMap(item => item.records) || [];
      
        // Count records where overall_status is "PENDING"
        const totalPending = allRecords.filter(record => record.overall_status === "PENDING").length;
      
        setCounts({
          All: allRecords.length,  // Total number of records
          Pending: totalPending    // Count of records with "PENDING" status
        });
      }
      
       else {
        setTableData([]);
        setBackpData([])
        setCounts({
          All:0,
          Pending:0,
        })
      }
    } catch (error) {
      console.log(error);
    } finally {
      setTableLoading(false);
    }
  };
  
const applyfilter=(x)=>{

const filteredData = backupdata.map(supervisor => ({
  ...supervisor,
  records: x === 'Pending'
      ? supervisor.records.filter(record => record.overall_status === "PENDING")
      : supervisor.records // Keep all records if filter is not 'Pending'
}));
setTableData(filteredData)
}
  // useEffect(() => {
  //   if(user?.phone&&selectedDateRange){
  //        fetchtable();
  //   }
 
  // }, [selectedDateRange,user]);
  // useEffect(() => {
  //   // Sync Zustand's selectedWeek to local state on mount
  //   console.log(dayjs(selectedWeek.startDate),'sss')
  //   if (selectedWeek?.startDate && selectedWeek?.endDate) {
  //     setCurrentDate({
  //       startDate: dayjs(selectedWeek.startDate),
  //       endDate: dayjs(selectedWeek.endDate),
  //     });
  //   }
  // }, []);
  
  useEffect(() => {
    if(selectedWeek.startDate){
         fetchtable();
    }
    console.log(selectedWeek,'selectedwek')
 
  }, [selectedWeek,currentfilter]);
  return (
    <>
    <SideNavLayout>
      <div className=" bg-gray-100 max-h-[90vh] overflow-y-auto  w-full" style={{scrollbarWidth:"none"}}>
        <SvDashboardFilters
        counts={counts}
        currentfilter={currentfilter}
        setCurrentFilter={setCurrentFilter}
        applyfilter={applyfilter}
        selectedDateRange={selectedDateRange}
        setSelectedDateRange={setSelectedDateRange}
        updateWeek={updateWeek}
        currentDate={selectedWeek}
        />
        <div className="flex flex-col items-start  self-stretch p-5 rounded-lg border border-gray-300 bg-[#FFF] shadow-sm mb-4">
          <h2 className="text-xl font-inter font-bold text-gray-900">{`${user?.firstname||''} ${user?.lastname||''}`}</h2>
          <p className="text-xs font-semibold text-[#71717A]">{`${user?.user_roles?.role||''}`}</p>
        </div>
          <div className="w-full">
          {tableLoading ? (
          <div className="flex justify-center items-center min-w-[1000px] h-40 w-full a">
            <CircularProgress />
          </div>
        ) : (
          <WeekTable tableData ={tableData} />
        )}

          </div>
      
        <div className="mb-8 mt-4">
     
        </div>
        <Footer/>
      </div>
     
    </SideNavLayout>
    </>
  );
};

export default SuperVisorView;
